import type { Tables } from "@msuite/utils/types";
import { Tag, type TagProps } from "./tag";

/** Props Interface */
interface WorkspaceTagProps extends Partial<TagProps> {
	workspace: Pick<Tables<"workspaces">, "name" | "color"> | undefined;
}

export function WorkspaceTag({
	workspace,
	variant = "plain",
	size,
	withPing,
	className,
}: WorkspaceTagProps) {
	/** Guard */
	if (!workspace) return null;

	/** Render */
	return (
		<Tag
			variant={variant}
			size={size}
			color={workspace.color}
			withPing={withPing}
			className={className}
		>
			{workspace.name}
		</Tag>
	);
}
